/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AffidavitMetadataResponse
 */
export interface AffidavitMetadataResponse {
    /**
     * 
     * @type {string}
     * @memberof AffidavitMetadataResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AffidavitMetadataResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AffidavitMetadataResponse
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof AffidavitMetadataResponse
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AffidavitMetadataResponse
     */
    formattedAddress: string;
    /**
     * 
     * @type {Date}
     * @memberof AffidavitMetadataResponse
     */
    submittedAt: Date;
}

/**
 * Check if a given object implements the AffidavitMetadataResponse interface.
 */
export function instanceOfAffidavitMetadataResponse(value: object): value is AffidavitMetadataResponse {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('formattedAddress' in value) || value['formattedAddress'] === undefined) return false;
    if (!('submittedAt' in value) || value['submittedAt'] === undefined) return false;
    return true;
}

export function AffidavitMetadataResponseFromJSON(json: any): AffidavitMetadataResponse {
    return AffidavitMetadataResponseFromJSONTyped(json, false);
}

export function AffidavitMetadataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffidavitMetadataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'companyName': json['companyName'],
        'registrationNumber': json['registrationNumber'],
        'formattedAddress': json['formattedAddress'],
        'submittedAt': (new Date(json['submittedAt'])),
    };
}

export function AffidavitMetadataResponseToJSON(value?: AffidavitMetadataResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'companyName': value['companyName'],
        'registrationNumber': value['registrationNumber'],
        'formattedAddress': value['formattedAddress'],
        'submittedAt': ((value['submittedAt']).toISOString().substring(0,10)),
    };
}

